import { render } from "./HeroiconsOutlineVariable.vue?vue&type=template&id=7d8b39ce"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineVariable.vue"]])

export default __exports__